// App.js
import { BrowserRouter as Router } from "react-router-dom";
import "./App.css";
import HeaderComponent from "./components/header/HeaderComponent";
import AppRoutes from "./routes";
import FooterComponent from "./components/footer/FooterComponent";

const App = () => {
  return (
    <div className="d-flex flex-column min-vh-100">
      <Router basename={process.env.PUBLIC_URL}>
        <HeaderComponent />
        <div className="flex-grow-1">
          <AppRoutes />
        </div>
        <FooterComponent />
      </Router>
    </div>
  );
};

export default App;